import React from 'react';
import * as Yup from 'yup';
import AddressInput from './AddressInput';

import {
    FormControl,
    Input,
    FormLabel,
    HStack,
    Button,
    VStack,
    Box,
    FormErrorMessage
} from '@chakra-ui/react';
import SelectInput from 'components/Input/SelectInput';
import statelist from 'constants/Select-constants/stateslist.json';

import { Formik, Form, useField } from 'formik';
import { LENDER_FORM_DEFAULT } from 'constants/index';
import { useUpdateLenderMutation } from 'reducers/company.service';

const TextField = ({ label, ...props }) => {
    const [field, meta] = useField(props);
    return (
        <FormControl isInvalid={meta.touched && !!meta.error} mb={4}>
            <FormLabel>{label}</FormLabel>
            <Input {...field} {...props} />
            <FormErrorMessage>{meta.error}</FormErrorMessage>
        </FormControl>
    );
};

export default function LenderForm ({ defaultValues = LENDER_FORM_DEFAULT, data, afterUpdateHandler = ()=>{}, handleCancel = ()=>{} }) {
    const [updateLender, { isLoading }] = useUpdateLenderMutation();

    const handleUpdate = (values, actions)=>{
        values.Statelicenses = values.Statelicenses.map((row)=> row?.value || row);
        updateLender({ id: data?._id , body: values }).unwrap().then(()=>{
            afterUpdateHandler();
        });
    };

    return (
        <Formik
            initialValues={defaultValues}
            validationSchema={Yup.object({
                FirstName: Yup.string().required('Required'),
                LastName: Yup.string().required('Required'),
                NMLS: Yup.string(),
                Statelicenses: Yup.array().optional().label('State Licenses')
            })}
            onSubmit={handleUpdate}
        >
            {({ handleSubmit , setValues, setFieldValue }) => (
                <Form onSubmit={handleSubmit}>
                    <VStack align="stretch" spacing={4}>
                        <TextField name="FirstName" label="First Name" />
                        <TextField name="LastName" label="Last Name" />
                        <TextField name="NMLS" label="NMLS" />
                        <TextField name="ContactPointTelephonePrefix" label="Cell Prefix" />

                        <TextField name="ContactPointTelephoneValue" label="Cell Number" />

                        <SelectInput
                            issearch={true}
                            name={'Statelicenses'}
                            isMulti ={true}
                            required={true}
                            label={'State Licenses'}
                            options={statelist}
                            defaultValue={[]}
                        />

                        <Box>
                            <AddressInput />
                        </Box>
                        <HStack justify="flex-end" gap={'0.5rem'}>
                            <Button variant="outline" type="reset" onClick={handleCancel }>
                                Cancel
                            </Button>
                            <Button disabled={isLoading} colorScheme="blue" type="submit">
                                {
                                    isLoading ? 'Saving...' : 'Save'
                                }
                            </Button>
                        </HStack>
                    </VStack>
                </Form>
            )}
        </Formik>
    );
}
